/* (09-10, Thomas) Virtuele try-on: LIVE voor alle bezoekers sinds 09-10. Voor iedereen uitzetten: AAN = false.
   Eigen browser uit met ?tryon=0, weer aan met ?tryon=1. Laadt lt-tryon.js/.css. */
(function () {
  var AAN = true;
  var q = location.search, uit = false;
  try {
    if (/[?&]tryon=0\b/.test(q)) localStorage.setItem('lt-tryon', '0');
    if (/[?&]tryon=1\b/.test(q)) localStorage.setItem('lt-tryon', '1');
    uit = localStorage.getItem('lt-tryon') === '0';
  } catch (e) { uit = /[?&]tryon=0\b/.test(q); }
  if (!AAN || uit) return;
  var me = document.currentScript && document.currentScript.src;
  if (!me || me.indexOf('lt-nagelbox.js') === -1) return;
  var V = '20261016090147', base = me.split('lt-nagelbox.js')[0];
  var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = base + 'lt-tryon.css?v=' + V; document.head.appendChild(l);
  var s = document.createElement('script'); s.src = base + 'lt-tryon.js?v=' + V; s.defer = true; document.head.appendChild(s);
})();
/*
  Lashthing nagelbox (08-10-2026, opdracht Thomas: "bouw dit na").
  Stap-voor-stap kiezer voor 3 en 5 nagelsets, nagebouwd naar de 'Build your box' van Sassy Saints
  (sassysaints.com/products/uv-free-gel-wraps, snippet btf-bb): stap 1 betaalde designs, vrijspeel-scherm met
  confetti, stap 2 gratis designs, stap 3 extra's (paste/lamp, alleen als ze leverbaar zijn), daarna het overzicht.

  Werkt bovenop snippets/nagels-kleurkiezer.liquid: die zet window.ltNagelKiezer (designs, aantal sets, prijzen,
  extra's) en opent deze box in plaats van de oude pop-up. De box schrijft elke keuze terug naar de kiezer, dus de
  vakjes, het designoverzicht en de koopknop op de pagina lopen mee. Prijzen, kortingen en afrekenen blijven die van
  de kiezer (cart/add.js + automatische kortingen 2+1 / 3+2 / Black November 2+3).

  Bewust NIET overgenomen van Sassy: de vaste '93% verkocht'-balk en 'viraal op TikTok' (verzonnen schaarste),
  de 'herbevoorrading op [datum], volle prijs'-regel en het gratis welkomstpakket (bestaat bij ons niet).
  In plaats daarvan: de echte leverregel van de pagina, de garantie (niet in actieperiodes) en de verzenddrempel.

  Uitzetten: ?box=0 in de URL (dan opent de oude pop-up), of dit bestand niet laden in de kiezer.
*/
(function () {
  'use strict';

  var FREE_SHIP = 5995; // gratis verzending met DHL vanaf €59,95 (aankondigingsbalk)
  var SHIP_COST = 395; // verzendkosten onder de drempel (verzendpagina)
  // Zit in elke nagelset (zie 'Wat zit er in de set?'), getoond als gratis items in het overzicht (Thomas 08-10)
  var GIFTS = [
    { name: 'Nagellijm 2 ml', worth: 500, icon: 'drop' },
    { name: 'Press-on tabs', worth: 400, icon: 'tips' },
    { name: 'Nagelvijl', worth: 395, icon: 'file' }
  ];
  // Sassy-schaarsteblok zichtbaar voor alle bezoekers.
  // Geen automatische einddatum.
  
  // Leverdag: zelfde regels als #delivery-message op de pagina (ma-vr tot 23:59 morgen, za + zo dinsdag; vrijdag sinds 08-10-2026 ook 23:59)
  function leverDag() {
    var d = new Date().getDay();
    return d >= 1 && d <= 5 ? 'Morgen' : 'Dinsdag';
  }
  var URG_MIN = 50; // schaarsteblok pas tonen vanaf 50% van de voorraad van vandaag verkocht (echte cijfers)
  var LIVE = true; // false = alleen met ?box=1 (testen op het live thema); true = voor iedereen

  function boot() {
    var K = window.ltNagelKiezer;
    if (!K || (window.ltNagelBox && window.ltNagelBox.ready)) return;
    if (/[?&]box=0\b/.test(location.search)) return;
    if (!LIVE && !/[?&]box=1\b/.test(location.search)) return;

    var MOTION = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var DESKTOP = window.matchMedia('(min-width: 768px)');
    var ORD = ['eerste', 'tweede', 'derde', 'vierde', 'vijfde'];
    var WORDS = ['nul', 'één', 'twee', 'drie', 'vier', 'vijf'];
    var C = {
      step1First: 'Kies je eerste *design.*',
      step1Next: 'Nu je *[ordinal] design.*',
      unlockLabel: 'Vrijgespeeld',
      unlockHeading: 'Goede *keuze.*',
      unlockTitle1: 'Je hebt *1 gratis set* vrijgespeeld.',
      unlockTitleN: 'Je hebt *[free] gratis sets* vrijgespeeld.',
      unlockSub1: 'T.w.v. [worth]. Kies zelf welke.',
      unlockSubN: 'Samen t.w.v. [worth]. Kies er zelf [free_word].',
      unlockCta1: 'Kies mijn gratis design',
      unlockCtaN: 'Kies mijn gratis designs',
      step2First: 'Kies je eerste *gratis design.*',
      step2Next: 'Nu je [ordinal] *gratis design.*',
      step2One: 'Kies je *gratis design.*',
      kitLabel: 'Maak je set compleet',
      kitHeading: 'Bijna *klaar.*',
      cartTitle: 'Jouw *selectie*',
      slotPaid: 'Design [n]',
      slotFree: 'Gratis',
      swapLabel: 'Je wisselt [slot]',
      swapHeading: 'Kies een *ander design.*',
      swapKeep: 'Houd [name]',
      add: 'Kies',
      addFree: 'Voeg gratis toe',
      out: 'Uitverkocht',
      change: 'Wissel',
      itemSub: 'Press-on nagels · 30 stuks',
      freeTitle: 'Jouw gratis *items*',
      freeTag: 'Gratis',
      checkout: 'Door naar afrekenen',
      addCart: 'Voeg toe aan winkelwagen',
      addedTitle: 'In je *winkelwagen*',
      shopOn: 'Voeg toe aan winkelwagen, ga door met shoppen',
      error: 'Dat lukte niet. Probeer het opnieuw.'
    };

    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function em(s) { return esc(s).replace(/\*([^*]+)\*/g, '<em>$1</em>'); }
    function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
    var money = K.money;

    var ICON = {
      plus: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M9 3.5v11M3.5 9h11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
      lock: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path class="nb-shackle" d="M6.2 8V5.9a2.8 2.8 0 0 1 5.6 0V8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><rect x="4" y="8" width="10" height="7.5" rx="1.6" stroke="currentColor" stroke-width="1.3"/></svg>',
      check: '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true"><path d="m2.3 5.7 2.1 2.1 4.3-4.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      truck: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1.5 4h8v6.5h-8zM9.5 6.5h2.6l2.4 2.4v1.6h-5" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="4.3" cy="11.6" r="1.3" fill="#fff" stroke="currentColor" stroke-width="1.3"/><circle cx="11.8" cy="11.6" r="1.3" fill="#fff" stroke="currentColor" stroke-width="1.3"/></svg>',
      shield: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 1.8 13.2 4v3.6c0 3.2-2.2 5.8-5.2 6.6-3-.8-5.2-3.4-5.2-6.6V4z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="m5.6 8.1 1.7 1.7 3.2-3.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      box: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 5.2 8 2l6 3.2v5.6L8 14l-6-3.2z M2 5.2 8 8.4l6-3.2M8 8.4V14" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>',
      drop: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 2.4S4.6 7.2 4.6 10.6a4.4 4.4 0 0 0 8.8 0C13.4 7.2 9 2.4 9 2.4Z"/></svg>',
      tips: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.2 15.5V7.6a2.8 2.8 0 0 1 5.6 0v7.9z"/><path d="M6.2 9.6h5.6"/></svg>',
      file: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><g transform="rotate(-45 9 9)"><rect x="1.6" y="6.4" width="14.8" height="5.2" rx="1"/><path d="M4.6 6.4v2M7 6.4v2.6M9.4 6.4v2M11.8 6.4v2.6"/></g></svg>',
      ship: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" aria-hidden="true"><path d="M1.8 4.6h8.8v7.2H1.8zM10.6 7.4h2.9l2.7 2.7v1.7h-5.6"/><circle cx="4.9" cy="13.2" r="1.4" fill="none"/><circle cx="13.2" cy="13.2" r="1.4" fill="none"/></svg>',
      star: '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path fill="#02b77a" d="m7 .9 1.8 3.8 4.1.5-3 2.9.8 4.1L7 10.2l-3.7 2 .8-4.1-3-2.9 4.1-.5z"/></svg>',
      arrowL: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m12.5 15-5-5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      arrowR: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m7.5 15 5-5-5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      minus12: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1.5 6h9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      plus12: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M6 1.5v9M1.5 6h9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      close: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M12 4 4 12M4 4l8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
    };

    /* ---------- designs uit de kiezer ---------- */
    var DESIGNS = K.cards.map(function (c) {
      var imgs = String(c.dataset.images || '').split('||').filter(Boolean);
      return {
        id: c.dataset.id,
        name: c.dataset.title,
        price: Number(c.dataset.price) || K.unit,
        image: imgs[0] || c.dataset.image || '',
        thumb: c.dataset.thumb || c.dataset.image || imgs[0] || '',
        avail: c.dataset.avail === '1'
      };
    });
    var byId = {};
    DESIGNS.forEach(function (d) { byId[d.id] = d; });

    /* ---------- opbouw ---------- */
    var root = document.createElement('div');
    root.id = 'lt-nagelbox';
    root.className = 'nb-root';
    root.dataset.phase = 'paid';
    root.setAttribute('aria-hidden', 'true');
    var cardsHtml = DESIGNS.map(function (d) {
      return '<div class="nb-card' + (d.avail ? '' : ' is-out') + '" data-id="' + esc(d.id) + '">' +
        '<div class="nb-card-media">' +
        (d.image ? '<img src="' + esc(d.image) + '" alt="' + esc(d.name) + '" loading="lazy" draggable="false" width="340" height="432">' : '<span class="nb-nofoto">Foto volgt</span>') +
        '<button type="button" class="nb-pill nb-card-add" aria-label="' + esc(d.name) + ' kiezen"' + (d.avail ? '' : ' disabled') + '>' +
        (d.avail ? ICON.plus12 : '') + '<span class="nb-add-text">' + (d.avail ? C.add : C.out) + '</span></button>' +
        '<div class="nb-pill nb-card-stepper">' +
        '<button type="button" class="nb-step-minus" aria-label="Eén ' + esc(d.name) + ' minder">' + ICON.minus12 + '</button>' +
        '<span class="nb-step-count" aria-live="polite">1</span>' +
        '<button type="button" class="nb-step-plus" aria-label="Nog een ' + esc(d.name) + '">' + ICON.plus12 + '</button>' +
        '</div></div><p class="nb-card-name">' + esc(d.name) + '</p></div>';
    }).join('');

    root.innerHTML =
      '<div class="nb-blur" aria-hidden="true"></div><div class="nb-backdrop" data-nb-close></div>' +
      '<div class="nb-sheet" role="dialog" aria-modal="true" aria-labelledby="nb-title" tabindex="-1">' +
      '<div class="nb-bg" aria-hidden="true"><div class="nb-wine"></div></div><div class="nb-handle" aria-hidden="true"></div>' +
      '<div class="nb-inner">' +
      '<header class="nb-head"><div class="nb-head-text"><p class="nb-label"></p><h2 class="nb-title" id="nb-title"></h2></div>' +
      '<button type="button" class="nb-close" data-nb-close aria-label="Sluiten">' + ICON.close + '</button></header>' +
      '<div class="nb-progress" aria-hidden="true"></div>' +
      '<div class="nb-slots" role="list" aria-label="Jouw sets"></div>' +
      '<div class="nb-view nb-view-pick"><div class="nb-carousel">' +
      '<button type="button" class="nb-arrow nb-arrow-prev" aria-label="Vorige designs">' + ICON.arrowL + '</button>' +
      '<div class="nb-track">' + cardsHtml + '</div>' +
      '<button type="button" class="nb-arrow nb-arrow-next" aria-label="Volgende designs">' + ICON.arrowR + '</button>' +
      '</div><button type="button" class="nb-swap-keep"></button></div>' +
      '<div class="nb-view nb-view-unlock"><div class="nb-collage" aria-hidden="true">' +
      '<div class="nb-tile nb-tile-1"><img alt="" width="118" height="118"></div><div class="nb-tile nb-tile-2"><img alt="" width="118" height="118"></div>' +
      '<div class="nb-tile nb-tile-3"><img alt="" width="118" height="118"></div><div class="nb-tile nb-tile-4"><img alt="" width="118" height="118"></div>' +
      '<div class="nb-badge"><span class="nb-badge-num">1</span><span class="nb-badge-text">gratis set</span></div></div>' +
      '<div class="nb-unlock-copy"><h3 class="nb-big-title nb-unlock-title"></h3><p class="nb-unlock-sub"></p>' +
      '<button type="button" class="nb-btn nb-btn-light nb-unlock-cta"></button></div></div>' +
      '<div class="nb-view nb-view-kit"><h3 class="nb-big-title nb-kit-title">Maak je set <em>compleet.</em></h3>' +
      '<p class="nb-kit-sub">Voor de langste draagtijd zet je ze met de UV Bonding Paste en de led-lamp. Heb je die al? Dan heb je ze niet nodig.</p>' +
      '<ul class="nb-kit-list" role="list"></ul>' +
      '<button type="button" class="nb-btn nb-btn-dark nb-kit-cta">Naar mijn overzicht</button></div>' +
      '<div class="nb-view nb-view-cart"><div class="nb-cart-main"><p class="nb-prior" hidden></p><ul class="nb-cart-items" role="list"></ul>' +
      '<ul class="nb-addon-lines" role="list"></ul><div class="nb-ship-tip" hidden></div>' +
      '<div class="nb-free-box"><p class="nb-free-title">' + em(C.freeTitle) + '</p><ul class="nb-free-items" role="list"></ul>' +
      '<div class="nb-free-sum"><span class="nb-free-sum-label">Jij krijgt gratis</span><span class="nb-free-sum-amount"></span></div></div></div>' +
      '<div class="nb-cart-side"><div class="nb-urgency" hidden>' +
      '<p class="nb-urgency-line"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M14.7 4.7 9 10.3 6.3 7.7 1.3 12.7M14.7 4.7h-4m4 0v4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="nb-urgency-text"></span></p>' +
      '<div class="nb-urgency-row nb-urgency-row-1"><span class="nb-urgency-fill"></span><span class="nb-urgency-label"></span><span class="nb-urgency-value"></span></div>' +
      '<div class="nb-urgency-row nb-urgency-row-2"><span class="nb-urgency-r2"></span><span class="nb-urgency-r2v"></span></div>' +
      '</div><div class="nb-facts"></div><div class="nb-summary">' +
      '<div class="nb-sum-row nb-sum-value"><span>Totale waarde</span><s class="nb-sum-value-amount"></s></div>' +
      '<div class="nb-sum-row nb-sum-total"><span>Totaal</span><span class="nb-sum-total-amount"></span></div>' +
      '<button type="button" class="nb-btn nb-btn-dark nb-checkout"><span class="nb-checkout-text"></span><span class="nb-spinner" aria-hidden="true"></span></button>' +
      '<button type="button" class="nb-btn nb-more" hidden><span class="nb-more-text"></span><span class="nb-spinner" aria-hidden="true"></span></button>' +
      '<p class="nb-error" role="alert" hidden></p>' +
      '<div class="nb-rating"><span class="nb-stars" aria-hidden="true">' + ICON.star + ICON.star + ICON.star + ICON.star + ICON.star + '</span>' +
      '<b>4,7 Uitstekend</b><span class="nb-rating-divider" aria-hidden="true"></span><span>50.000+ tevreden klanten</span></div>' +
      '</div></div></div>' +
      '</div></div>';
    document.body.appendChild(root);

    var sheet = root.querySelector('.nb-sheet');
    var labelEl = root.querySelector('.nb-label');
    var titleEl = root.querySelector('.nb-title');
    var headText = root.querySelector('.nb-head-text');
    var progressEl = root.querySelector('.nb-progress');
    var slotsEl = root.querySelector('.nb-slots');
    var track = root.querySelector('.nb-track');
    var prevBtn = root.querySelector('.nb-arrow-prev');
    var nextBtn = root.querySelector('.nb-arrow-next');
    var cards = [].slice.call(root.querySelectorAll('.nb-card'));
    var checkoutBtn = root.querySelector('.nb-checkout');
    var errorEl = root.querySelector('.nb-error');
    // (01-11, Thomas: 'mensen kunnen niet 8 nagels bestellen') tweede knop: deze sets in de winkelwagen en nog een ronde kiezen
    var moreBtn = root.querySelector('.nb-more');
    var priorEl = root.querySelector('.nb-prior');
    var prior = { sets: 0, cents: 0, full: 0 };
    // (02-11, Thomas) na 'Voeg toe aan winkelwagen': sets staan echt in de mand, kiezer is leeg, het overzicht toont
    // wat er net in ging (bedragen vastgelegd vóór het legen) met 'Door naar afrekenen' en 'Ga door met shoppen'.
    var added = null;

    /* ---------- toestand ---------- */
    // W = aantal sets, P = betaalde sets, F = gratis sets; picks[0..P-1] betaald, picks[P..W-1] gratis (zelfde volgorde als de kiezer)
    var W = 3, P = 2, F = 1, EXTRAS = [];
    var state = { phase: 'paid', picks: [], swap: null, unlocking: false };
    var advanceTimer = null, lastFocus = null, busy = false, slotEls = [], progressSegs = [];

    function hasKit() { return EXTRAS.length > 0; }
    function steps() { return F > 0 ? (hasKit() ? 3 : 2) : (hasKit() ? 2 : 1); }
    function range() {
      if (state.swap) return [state.swap.index, state.swap.index + 1];
      return state.phase === 'free' ? [P, W] : [0, P];
    }
    function basePhase() { return state.swap ? state.swap.back : state.phase; }
    function slotName(i) { return i >= P ? C.slotFree : fill(C.slotPaid, { n: i + 1 }); }
    function slotLongName(i) { return i >= P ? 'gratis set ' + (i - P + 1) : 'design ' + (i + 1); }
    function filledIn(a, b) { var n = 0; for (var i = a; i < b; i++) if (state.picks[i]) n++; return n; }
    function isOpen() { return root.classList.contains('is-open'); }
    function cardEl(id) { for (var i = 0; i < cards.length; i++) if (cards[i].dataset.id === String(id)) return cards[i]; return null; }
    function writeBack() { K.setPicks(state.picks.map(function (p) { return p ? p.id : null; })); }
    function compact(a, b) {
      var kept = state.picks.slice(a, b).filter(Boolean);
      for (var i = a; i < b; i++) state.picks[i] = kept[i - a] || null;
    }

    // Lees de kiezer: aantal sets, wat al gekozen is (vakje 1 = design van de pagina) en welke extra's er zijn.
    function sync() {
      W = K.n(); P = Math.min(K.pay(), W); F = W - P;
      EXTRAS = K.addons();
      var ids = K.picks();
      state.picks = [];
      for (var i = 0; i < W; i++) { var d = ids[i] && byId[ids[i]]; state.picks.push(d && d.avail ? d : null); }
      compact(0, P); compact(P, W);
      buildSlots();
      buildProgress();
      buildKit();
    }
    function startPhase(want) {
      var paidFull = filledIn(0, P) === P, freeFull = filledIn(P, W) === F;
      if (!paidFull) return 'paid';
      if (!freeFull) return filledIn(P, W) > 0 ? 'free' : (F > 0 ? 'unlock' : 'free');
      if (want === 'cart') return 'cart';
      return 'cart';
    }

    /* ---------- vakjes ---------- */
    function buildSlots() {
      slotsEl.innerHTML = '';
      slotEls = [];
      for (var i = 0; i < W; i++) {
        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'nb-slot';
        el.setAttribute('role', 'listitem');
        el.dataset.index = i;
        el.dataset.kind = i >= P ? 'free' : 'paid';
        el.innerHTML = '<span class="nb-slot-box"><svg class="nb-slot-dash" viewBox="0 0 64 64" preserveAspectRatio="none" aria-hidden="true"><rect x="1" y="1" width="62" height="62" rx="11" vector-effect="non-scaling-stroke"/></svg><span class="nb-slot-icon"></span><img class="nb-slot-img" alt="">' +
          '<span class="nb-slot-check">' + ICON.check + '</span></span><span class="nb-slot-label"></span>';
        if (i >= P) el.style.setProperty('--ld', ((i - P) * 0.09) + 's');
        slotsEl.appendChild(el);
        slotEls.push(el);
      }
    }
    function slotSpec(i) {
      var ph = state.phase, base = basePhase();
      var spec = { cls: [], icon: '', img: '', check: false, editable: false, label: slotName(i) };
      var pick = state.picks[i], isFree = i >= P;
      if (state.swap && state.swap.index === i) spec.cls.push('is-swapping');
      if (pick) {
        spec.cls.push('is-filled');
        spec.img = pick.image || pick.thumb; // zelfde bestand als de kaart: al geladen, dus direct zichtbaar
        spec.check = ph === 'unlock' || ph === 'kit';
        spec.editable = !state.swap || state.swap.index !== i;
        if (spec.editable) spec.cls.push('is-editable');
        return spec;
      }
      var firstEmpty = state.picks.indexOf(null);
      if (!isFree) {
        spec.icon = 'plus';
        if (ph === 'paid' && i === firstEmpty) spec.cls.push('is-active');
      } else if (base === 'paid') {
        spec.icon = 'lock';
        spec.cls.push('is-locked');
        if (state.unlocking) spec.cls.push('lock-open');
      } else if (ph === 'unlock') {
        spec.icon = 'lock';
        spec.cls.push('is-unlocked', 'lock-open');
      } else {
        spec.icon = 'lock';
        spec.cls.push('lock-open');
        if (ph === 'free' && !state.swap && i === firstEmpty) spec.cls.push('is-active');
        else spec.cls.push('is-locked');
      }
      return spec;
    }
    function updateSlot(el, spec) {
      el.className = 'nb-slot' + (spec.cls.length ? ' ' + spec.cls.join(' ') : '') + (spec.check ? ' has-check' : '');
      var iconEl = el.querySelector('.nb-slot-icon');
      if (iconEl.dataset.icon !== spec.icon) { iconEl.dataset.icon = spec.icon; iconEl.innerHTML = spec.icon ? ICON[spec.icon] : ''; }
      var img = el.querySelector('.nb-slot-img');
      if (spec.img && img.dataset.src !== spec.img) { img.src = spec.img; img.dataset.src = spec.img; }
      if (!spec.img && img.dataset.src) { img.removeAttribute('src'); img.dataset.src = ''; }
      var lbl = el.querySelector('.nb-slot-label');
      if (lbl.textContent !== spec.label) lbl.textContent = spec.label;
      var pickName = (state.picks[el.dataset.index] || {}).name;
      if (spec.editable) {
        el.removeAttribute('tabindex'); el.removeAttribute('aria-disabled');
        el.setAttribute('aria-label', C.change + ' ' + spec.label + ', ' + pickName);
      } else {
        el.setAttribute('tabindex', '-1'); el.setAttribute('aria-disabled', 'true'); el.removeAttribute('aria-label');
      }
    }
    function renderSlots() { slotEls.forEach(function (el, i) { updateSlot(el, slotSpec(i)); }); }

    function buildProgress() {
      progressEl.innerHTML = '';
      progressSegs = [];
      for (var i = 0; i < steps(); i++) { var s = document.createElement('span'); progressEl.appendChild(s); progressSegs.push(s); }
    }

    /* ---------- kop ---------- */
    function stepLabel(n, txt) { return 'Stap ' + n + ' van ' + steps() + ' · ' + txt; }
    function headerCopy() {
      var ph = state.phase;
      if (state.swap) return [fill(C.swapLabel, { slot: slotLongName(state.swap.index) }), C.swapHeading];
      if (ph === 'paid') {
        var n = filledIn(0, P);
        return [stepLabel(1, P === 1 ? 'Jouw design' : 'Jouw designs'), n === 0 ? C.step1First : fill(C.step1Next, { ordinal: ORD[Math.min(n, ORD.length - 1)] })];
      }
      if (ph === 'unlock') return [stepLabel(2, C.unlockLabel), C.unlockHeading];
      if (ph === 'free') {
        var f = filledIn(P, W);
        if (F === 1) return [stepLabel(2, 'Gratis design'), C.step2One];
        return [stepLabel(2, 'Gratis designs'), f === 0 ? C.step2First : fill(C.step2Next, { ordinal: ORD[Math.min(f, ORD.length - 1)] })];
      }
      if (ph === 'kit') return [stepLabel(steps(), C.kitLabel), C.kitHeading];
      return ['', added ? C.addedTitle : C.cartTitle];
    }
    function renderHeader(animate) {
      var copy = headerCopy(), html = em(copy[1]);
      if (titleEl.innerHTML !== html || labelEl.textContent !== copy[0]) {
        labelEl.textContent = copy[0];
        titleEl.innerHTML = html;
        if (animate && MOTION && isOpen()) headText.animate([{ opacity: 0, transform: 'translate3d(0,5px,0)' }, { opacity: 1, transform: 'none' }], { duration: 132, easing: 'cubic-bezier(.32,.72,0,1)' });
      }
      var map = F > 0 ? { paid: 1, unlock: 2, free: 2, kit: 3, cart: steps() } : { paid: 1, free: 1, kit: 2, cart: steps() };
      var on = map[state.phase] || 1;
      progressSegs.forEach(function (seg, i) { seg.classList.toggle('is-on', i < on); });
    }

    /* ---------- kaarten ---------- */
    function renderCards() {
      var addText = (state.swap ? state.swap.index >= P : state.phase === 'free') ? C.addFree : C.add;
      cards.forEach(function (card) {
        var a = card.querySelector('.nb-add-text');
        if (a && !card.classList.contains('is-out') && a.textContent !== addText) a.textContent = addText;
      });
      if (state.swap) {
        var cur = state.picks[state.swap.index];
        cards.forEach(function (card) {
          card.classList.remove('is-picked');
          card.classList.toggle('is-current', !!cur && card.dataset.id === cur.id);
        });
        root.querySelector('.nb-swap-keep').textContent = fill(C.swapKeep, { name: cur ? cur.name : '' });
        return;
      }
      var r = range(), full = filledIn(r[0], r[1]) >= r[1] - r[0];
      cards.forEach(function (card) {
        var id = card.dataset.id, count = 0;
        for (var i = r[0]; i < r[1]; i++) if (state.picks[i] && state.picks[i].id === id) count++;
        card.classList.toggle('is-picked', count > 0);
        card.classList.remove('is-current');
        var c = card.querySelector('.nb-step-count');
        if (c.textContent !== String(count)) c.textContent = count;
        card.querySelector('.nb-step-plus').disabled = full;
      });
    }

    /* ---------- vrijspeel-scherm ---------- */
    function renderUnlock() {
      var worth = 0;
      for (var i = P; i < W; i++) worth += K.unit;
      root.querySelector('.nb-unlock-title').innerHTML = em(F === 1 ? C.unlockTitle1 : fill(C.unlockTitleN, { free: F }));
      root.querySelector('.nb-unlock-sub').textContent = fill(F === 1 ? C.unlockSub1 : C.unlockSubN, { worth: money(worth), free_word: WORDS[F] || F });
      root.querySelector('.nb-unlock-cta').textContent = F === 1 ? C.unlockCta1 : C.unlockCtaN;
      root.querySelector('.nb-badge-num').textContent = F;
      root.querySelector('.nb-badge-text').textContent = F === 1 ? 'gratis set' : 'gratis sets';
      var picked = {};
      state.picks.forEach(function (p) { if (p) picked[p.id] = true; });
      var pool = DESIGNS.filter(function (d) { return d.avail && d.image && !picked[d.id]; });
      if (pool.length < 4) pool = DESIGNS.filter(function (d) { return d.image; });
      root.querySelectorAll('.nb-tile img').forEach(function (img, i) {
        var d = pool[i];
        if (d && img.getAttribute('src') !== (d.image || d.thumb)) img.src = d.image || d.thumb;
      });
    }

    /* ---------- stap 3: extra's ---------- */
    function buildKit() {
      var list = root.querySelector('.nb-kit-list');
      list.innerHTML = EXTRAS.map(function (x) {
        return '<li class="nb-kit-item' + (x.on ? ' is-on' : '') + '" data-id="' + esc(x.id) + '">' +
          '<div class="nb-kit-thumb">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="68" height="68">' : '') + '</div>' +
          '<div class="nb-kit-body"><p class="nb-kit-name">' + esc(x.name) + '</p>' + (x.sub ? '<p class="nb-kit-meta">' + esc(x.sub) + '</p>' : '') +
          '<p class="nb-kit-price-now">+' + money(x.price) + '</p></div>' +
          '<button type="button" class="nb-kit-toggle" aria-pressed="' + (x.on ? 'true' : 'false') + '">' + (x.on ? ICON.check + ' Toegevoegd' : 'Voeg toe') + '</button></li>';
      }).join('');
    }
    function toggleExtra(li) {
      var id = li.dataset.id, x = EXTRAS.filter(function (e) { return e.id === id; })[0];
      if (!x) return;
      x.on = !x.on;
      K.setAddon(id, x.on);
      li.classList.toggle('is-on', x.on);
      var b = li.querySelector('.nb-kit-toggle');
      b.setAttribute('aria-pressed', x.on ? 'true' : 'false');
      b.innerHTML = x.on ? ICON.check + ' Toegevoegd' : 'Voeg toe';
      if (MOTION && x.on) {
        li.querySelector('.nb-kit-thumb').animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'cubic-bezier(.2,.9,.3,1.3)' });
      }
    }

    /* ---------- overzicht ---------- */
    function line(thumb, name, sub, price) {
      return '<li class="nb-line"><div class="nb-line-thumb">' + (thumb ? '<img src="' + esc(thumb) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="nb-line-body"><p class="nb-line-name">' + esc(name) + '</p>' + (sub ? '<p class="nb-line-sub">' + esc(sub) + '</p>' : '') + '</div>' +
        '<span class="nb-line-price">' + price + '</span></li>';
    }
    function renderCart() {
      // Betaald = de duurste sets (zoals de korting in Shopify rekent); alle nagelsets kosten nu hetzelfde.
      // Zelfde design meerdere keren = één regel met aantal (overzicht blijft kort op de telefoon)
      function groups(a, b) {
        var out = [], at = {};
        for (var g = a; g < b; g++) {
          var q0 = state.picks[g];
          if (!q0) continue;
          if (at[q0.id] != null) out[at[q0.id]].n++;
          else { at[q0.id] = out.length; out.push({ d: q0, n: 1 }); }
        }
        return out;
      }
      function setSub(n) { return n > 1 ? n + ' sets · 30 stuks per set' : C.itemSub; }
      var items = '';
      groups(0, P).forEach(function (g) { items += line(g.d.image || g.d.thumb, (g.n > 1 ? g.n + '× ' : '') + g.d.name, setSub(g.n), money(g.d.price * g.n)); });
      root.querySelector('.nb-cart-items').innerHTML = items;
      errorEl.hidden = true;
      var free = '';
      groups(P, W).forEach(function (g) {
        var q = g.d;
        free += '<li class="nb-line nb-free-line"><div class="nb-line-thumb"><img src="' + esc(q.image || q.thumb) + '" alt="" loading="lazy"></div>' +
          '<div class="nb-line-body"><p class="nb-line-name">' + (g.n > 1 ? g.n + '× ' : '') + esc(q.name) + '</p><p class="nb-line-sub">' + esc(setSub(g.n)) + '</p></div><span class="nb-line-free"><s>' + money(q.price * g.n) + '</s><span class="nb-free-tag">' + C.freeTag + '</span></span></li>';
      });
      root.querySelector('.nb-addon-lines').innerHTML = EXTRAS.filter(function (x) { return x.on; }).map(function (x) { return line(x.img, x.name, '', money(x.price)); }).join('');
      var total = (added ? added.cents : K.total()) + prior.cents, full = (added ? added.full : K.fullTotal()) + prior.full, shipFree = total >= FREE_SHIP;
      if (prior.sets > 0) {
        priorEl.innerHTML = ICON.check + '<span>Al in je winkelwagen: <b>' + prior.sets + (prior.sets === 1 ? ' set' : ' sets') + '</b></span><span class="nb-prior-price">' + money(prior.cents) + '</span>';
        priorEl.hidden = false;
      } else { priorEl.hidden = true; priorEl.innerHTML = ''; }
      // (02-11 v6, Thomas) meteen twee knoppen: 'Door naar afrekenen' en daaronder 'Voeg toe aan winkelwagen, ga door met shoppen'
      moreBtn.querySelector('.nb-more-text').textContent = C.shopOn;
      moreBtn.hidden = false;
      function giftLine(icon, name, worth) {
        return '<li class="nb-line nb-free-line nb-line-kit"><div class="nb-line-icon" aria-hidden="true">' + ICON[icon] + '</div>' +
          '<p class="nb-line-name">' + esc(name) + '</p><span class="nb-line-free"><s>' + money(worth) + '</s><span class="nb-free-tag">' + C.freeTag + '</span></span></li>';
      }
      var extra = '';
      var giftSum = 0, giftNames = [];
      GIFTS.forEach(function (g) { extra += giftLine(g.icon, g.name, g.worth).replace('nb-line-kit', 'nb-line-kit nb-gift-los'); full += g.worth; giftSum += g.worth; giftNames.push(g.name); });
      extra += giftLine('drop', 'Lijm, tabs en vijl', giftSum).replace('nb-line-kit', 'nb-line-kit nb-gift-samen');
      if (shipFree) { extra += giftLine('ship', leverDag() + ' in huis', SHIP_COST); full += SHIP_COST; }
      // Tip onder de drempel (Thomas 08-10): 'Voeg toe voor gratis verzending' + het goedkoopste extraatje dat je erover helpt
      var tip = root.querySelector('.nb-ship-tip'), cand = EXTRAS.filter(function (x) { return !x.on; });
      var over = cand.filter(function (x) { return total + x.price >= FREE_SHIP; }).sort(function (a, b) { return a.price - b.price; });
      var pickX = !shipFree && !added ? over[0] || null : null; // alleen als dit extraatje je echt over de drempel helpt
      if (pickX) {
        tip.innerHTML = '<div class="nb-tip-thumb">' + (pickX.img ? '<img src="' + esc(pickX.img) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="nb-tip-body"><p class="nb-tip-kop">Voeg toe voor gratis verzending</p>' +
          '<p class="nb-tip-sub">' + esc(pickX.name) + '</p></div>' +
          '<button type="button" class="nb-tip-add" data-id="' + esc(pickX.id) + '">+ ' + money(pickX.price) + '</button>';
        tip.hidden = false;
      } else { tip.hidden = true; tip.innerHTML = ''; }
      if (free && extra) free += '<li class="nb-free-divider" aria-hidden="true"></li>';
      free += extra;
      root.querySelector('.nb-free-items').innerHTML = free;
      var freeWorth = giftSum + (shipFree ? SHIP_COST : 0);
      groups(P, W).forEach(function (g) { freeWorth += g.d.price * g.n; });
      root.querySelector('.nb-free-sum-amount').textContent = 't.w.v. ' + money(freeWorth);
      root.querySelector('.nb-free-box').style.display = free ? '' : 'none';

      root.querySelector('.nb-sum-value').style.display = full > total ? '' : 'none';
      root.querySelector('.nb-sum-value-amount').textContent = money(full);
      root.querySelector('.nb-sum-total-amount').textContent = money(total);
      root.querySelector('.nb-checkout-text').textContent = C.checkout + ' · ' + money(total);

      // Echte feiten: leverregel van de pagina, verzenddrempel, garantie (niet tijdens acties zoals Black November).
      var facts = '';
      // (08-10) De leverdag staat nu in de verzendregel bij de gratis items; hier alleen nog onder de drempel
      // (09-10, Thomas: optie B) twee rustige tegels + dunne gouden verzendbalk i.p.v. twee volle zinnen
      function tile(icon, kop, sub, cls, title) {
        return '<div class="nb-fact nb-trust-tile' + (cls ? ' ' + cls : '') + '"' + (title ? ' title="' + title + '"' : '') + '>' + icon +
          '<span class="nb-trust-kop">' + kop + '</span><span class="nb-trust-sub">' + sub + '</span></div>';
      }
      var tiles = '';
      if (!shipFree) tiles += tile(ICON.truck, leverDag(), 'in huis');
      if (!document.documentElement.classList.contains('bf26-actief')) tiles += tile(ICON.shield, '30 dagen', 'geld terug', 'nb-fact-garantie', 'Niet goed? 30 dagen geld terug.');
      if (tiles) facts += '<div class="nb-trust-tiles">' + tiles + '</div>';
      if (!shipFree) facts += '<div class="nb-fact-wrap nb-ship"><p class="nb-ship-text">Nog ' + money(FREE_SHIP - total) + ' tot gratis verzending</p><div class="nb-ship-bar"><span style="--p:0"></span></div></div>';
      var fEl = root.querySelector('.nb-facts');
      fEl.innerHTML = facts;
      var bar = fEl.querySelector('.nb-ship-bar span');
      if (bar) requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.setProperty('--p', Math.min(1, total / FREE_SHIP).toFixed(3)); }); });
    }

    /* ---------- schaarste: zelfde blok als Sassy, met echte cijfers ----------
       Voorbeeldmodus (?sassy=1): de cijfers van Sassy 1-op-1 (93%, TikTok, levering over 35 dagen tegen normale prijs).
       Gewone bezoekers: % = vandaag verkochte nagelsets / (verkocht vandaag + voorraad), pas vanaf URG_MIN.
       Tweede regel alleen tijdens Black November (klopt dan: daarna geldt weer de normale prijs). */
    function renderUrgency() {
      var box = root.querySelector('.nb-urgency');
      var u = null;
      if (true) {
        var d = new Date(); d.setDate(d.getDate() + 35);
        u = { line: 'Viraal op TikTok: de voorraad raakt snel op', label: 'Vandaag verzonden', pct: 93,
              r2: 'Verzonden ' + d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }).replace('.', '') + ' · normale prijs', r2v: '0% verkocht' };
      } else {
        var sold = K.sold || 0, stock = K.stock || 0;
        var pct = sold > 0 && sold + stock > 0 ? Math.round(sold / (sold + stock) * 100) : 0;
        if (pct >= URG_MIN) {
          u = { line: 'Populair: vandaag al ' + sold + ' sets verkocht', label: 'Voorraad van vandaag', pct: Math.min(pct, 99) };
          if (document.documentElement.classList.contains('bf26-actief')) { u.r2 = 'Na Black November: normale prijs'; u.r2v = ''; }
        }
      }
      if (!u) { box.hidden = true; return; }
      box.hidden = false;
      box.querySelector('.nb-urgency-text').textContent = u.line;
      box.querySelector('.nb-urgency-label').textContent = u.label;
      var row1 = box.querySelector('.nb-urgency-row-1');
      row1.style.setProperty('--nb-fill', u.pct + '%');
      var val = box.querySelector('.nb-urgency-value');
      val.dataset.full = u.pct + '% verkocht';
      val.textContent = val.dataset.full;
      var row2 = box.querySelector('.nb-urgency-row-2');
      row2.hidden = !u.r2;
      if (u.r2) { box.querySelector('.nb-urgency-r2').textContent = u.r2; box.querySelector('.nb-urgency-r2v').textContent = u.r2v || ''; }
    }
    // Balk groeit en het percentage telt mee (alleen transform/opacity)
    function animateUrgency() {
      var box = root.querySelector('.nb-urgency');
      if (!box || box.hidden) return;
      var row = box.querySelector('.nb-urgency-row-1'), val = box.querySelector('.nb-urgency-value'), fillEl = row.querySelector('.nb-urgency-fill');
      var full = val.dataset.full || val.textContent, m = full.match(/\d+/), fillPx = fillEl ? fillEl.offsetWidth : 0;
      function set(p) {
        if (fillEl) fillEl.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        val.style.transform = 'translate3d(' + (-(1 - p) * fillPx).toFixed(1) + 'px,-50%,0)';
        val.style.opacity = Math.min(1, Math.max(0, (p - 0.3) / 0.2)).toFixed(3);
        if (m) val.textContent = full.replace(m[0], String(Math.round(parseInt(m[0], 10) * p)));
      }
      if (!MOTION) { set(1); val.textContent = full; return; }
      var delay = 250, dur = 2000, t0 = null; // (09-10, Thomas) langzamer oplopen, was 840ms
      function ease(t) { return 1 - Math.pow(1 - t, 3.2); }
      set(0);
      function step(ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, Math.max(0, (ts - t0 - delay) / dur));
        set(ease(t));
        if (t < 1 && isOpen()) requestAnimationFrame(step); else { set(1); val.textContent = full; }
      }
      requestAnimationFrame(step);
    }

    // Telefoon: het overzicht moet zonder scrollen passen (Thomas 08-10). Eerst compacte opmaak (CSS), past het dan nog
    // niet: stap 1 kleinere extra's (garantie/reviews weg), stap 2 cadeaus in één regel, stap 3 schaarste zonder 2e regel.
    function fitCart() {
      root.classList.remove('fit-1', 'fit-2', 'fit-3', 'fit-4');
      if (state.phase !== 'cart' || DESKTOP.matches) return;
      sheet.style.removeProperty('--nb-bgh'); // achtergrondlaag niet meetellen in de hoogte
      var lv = ['fit-1', 'fit-2', 'fit-3', 'fit-4'];
      for (var k = 0; k < lv.length && sheet.scrollHeight > sheet.clientHeight + 1; k++) root.classList.add(lv[k]);
      sizeBg();
    }

    function render(animateHeader) {
      root.dataset.phase = state.phase;
      root.classList.toggle('is-wine', state.phase === 'unlock');
      root.classList.toggle('is-swap', !!state.swap);
      renderHeader(animateHeader);
      renderSlots();
      if (state.phase === 'paid' || state.phase === 'free') renderCards();
      if (state.phase === 'unlock') renderUnlock();
      if (state.phase === 'cart') { renderCart(); renderUrgency(); fitCart(); } else root.classList.remove('fit-1', 'fit-2', 'fit-3', 'fit-4');
      scheduleArrows();
    }

    /* ---------- stappen ---------- */
    function nextPhase(from) {
      if (from === 'paid') return F > 0 ? 'unlock' : (hasKit() ? 'kit' : 'cart');
      if (from === 'unlock') return 'free';
      if (from === 'free') return hasKit() ? 'kit' : 'cart';
      return 'cart';
    }
    function viewFor(ph) { return root.querySelector('.nb-view-' + (ph === 'paid' || ph === 'free' ? 'pick' : ph)); }
    function prepareUnlock() {
      renderUnlock();
      root.querySelectorAll('.nb-tile img').forEach(function (img) { if (img.decode) img.decode().catch(function () {}); });
    }
    // Eerst de oude hoogte weghalen, anders telt de achtergrondlaag zichzelf mee (lege scrollruimte na een kleiner scherm)
    function sizeBg() { sheet.style.removeProperty('--nb-bgh'); sheet.style.setProperty('--nb-bgh', sheet.scrollHeight + 'px'); }
    window.addEventListener('resize', function () { if (isOpen()) { sizeBg(); fitUnlock(); fitCart(); clipBlur(60); } });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (isOpen()) { fitUnlock(); clipBlur(60); } });

    // Mobiel vrijspeel-scherm: collage zo groot als de telefoon toelaat, knop blijft in beeld.
    function fitUnlock() {
      if (state.phase !== 'unlock' || window.innerWidth >= 768) return;
      var collage = root.querySelector('.nb-collage'), cta = root.querySelector('.nb-unlock-cta'), sub = root.querySelector('.nb-unlock-sub');
      if (!collage || !cta) return;
      collage.style.setProperty('--z', '1');
      var sr = sheet.getBoundingClientRect();
      var pad = parseFloat(getComputedStyle(root.querySelector('.nb-inner')).paddingBottom) || 24;
      var maxH = parseFloat(getComputedStyle(sheet).maxHeight) || window.innerHeight * 0.94;
      var contentH = sub.getBoundingClientRect().bottom + 14 + cta.offsetHeight + pad - sr.top + sheet.scrollTop;
      var room = maxH - contentH;
      var maxByWidth = (collage.clientWidth * 0.45) / 118;
      var z = Math.max(0.42, Math.min(1.35, maxByWidth, (300 + room) / 300));
      collage.style.setProperty('--z', z.toFixed(3));
      sizeBg();
    }

    function goPhase(ph, opts) {
      opts = opts || {};
      clearTimeout(advanceTimer);
      if (busy) return;
      var oldView = viewFor(state.phase), sameView = viewFor(ph) === oldView;
      function swap() {
        var h0 = sheet.offsetHeight;
        state.unlocking = false;
        state.phase = ph;
        root.classList.toggle('is-quiet', !!opts.quiet);
        render(true);
        sheet.scrollTop = 0;
        if (ph === 'free' && track) track.scrollLeft = 0;
        fitUnlock();
        fitCart();
        var h1 = sheet.offsetHeight;
        sizeBg();
        if (isOpen() && !DESKTOP.matches) { setBlur(Math.min(h0, h1) - 40); clipBlur(280); }
        var view = viewFor(ph);
        if (MOTION && isOpen()) {
          var dh = h1 - h0;
          if (Math.abs(dh) > 2) {
            if (window.innerWidth < 768) {
              if (dh < 0) sheet.classList.add('is-skirt');
              var m = sheet.animate([{ transform: 'translate3d(0,' + dh + 'px,0)' }, { transform: 'translate3d(0,0,0)' }], { duration: 252, easing: 'cubic-bezier(.32,.72,0,1)' });
              m.onfinish = m.oncancel = function () { sheet.classList.remove('is-skirt'); };
            } else {
              sheet.classList.add('is-sizing');
              sheet.style.minHeight = '0px';
              var a = sheet.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 252, easing: 'cubic-bezier(.32,.72,0,1)' });
              a.onfinish = a.oncancel = function () { sheet.classList.remove('is-sizing'); sheet.style.minHeight = ''; sizeBg(); };
            }
          }
          if (view && !sameView) view.animate([{ opacity: 0, transform: 'translate3d(0,10px,0)' }, { opacity: 1, transform: 'none' }], { duration: 192, delay: 24, easing: 'cubic-bezier(.32,.72,0,1)', fill: 'backwards' });
        }
        if (ph === 'cart' && !opts.quiet) animateUrgency();
        if (ph === 'unlock' && !opts.quiet) {
          burstFrom(root.querySelector('.nb-badge'), 160, 110, 1);
          if (MOTION) {
            setTimeout(function () {
              root.querySelector('.nb-badge').animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }], { duration: 312, easing: 'cubic-bezier(.2,.9,.3,1.3)' });
              root.querySelector('.nb-badge-num').animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }], { duration: 336, easing: 'cubic-bezier(.2,.9,.3,1.3)' });
            }, 160);
          }
        }
        busy = false;
      }
      if (!MOTION || !isOpen() || opts.instant) { swap(); return; }
      busy = true;
      requestAnimationFrame(swap);
    }

    function maybeAdvance() {
      clearTimeout(advanceTimer);
      if (state.swap) return;
      var r = range();
      if (filledIn(r[0], r[1]) < r[1] - r[0]) {
        if (state.unlocking) { state.unlocking = false; renderSlots(); }
        return;
      }
      var wait = 250;
      if (state.phase === 'paid' && F > 0) {
        // design landt, dan zwaaien de slotjes van de gratis vakjes open, dan het vrijspeel-scherm
        prepareUnlock();
        setTimeout(function () { if (state.phase === 'paid' && !state.swap && filledIn(0, P) === P) { state.unlocking = true; renderSlots(); } }, 70);
        wait = 70 + 180 + (F - 1) * 55;
      }
      advanceTimer = setTimeout(function () {
        var rr = range();
        if (filledIn(rr[0], rr[1]) >= rr[1] - rr[0]) goPhase(nextPhase(state.phase));
      }, wait);
    }

    /* ---------- één design wisselen ---------- */
    function startSwap(i, instant) {
      if (busy || i >= W || !state.picks[i]) return;
      var back = state.swap ? state.swap.back : state.phase;
      state.swap = { index: i, back: back };
      goPhase(i < P ? 'paid' : 'free', { instant: instant });
      var cur = cardEl(state.picks[i].id);
      if (cur && track) setTimeout(function () { track.scrollTo({ left: Math.max(0, cur.offsetLeft - track.offsetLeft - 16), behavior: instant ? 'auto' : 'smooth' }); }, instant ? 0 : 130);
    }
    function endSwap(instant) {
      if (!state.swap) return;
      var back = state.swap.back;
      state.swap = null;
      goPhase(back, { quiet: true, instant: instant });
    }

    function addPick(card) {
      if (busy) return;
      var d = byId[card.dataset.id];
      if (!d || !d.avail) return;
      if (state.swap) {
        var idx = state.swap.index, same = state.picks[idx] && state.picks[idx].id === d.id;
        if (!same) { state.picks[idx] = d; writeBack(); render(true); pushIn(idx, card); }
        clearTimeout(advanceTimer);
        advanceTimer = setTimeout(endSwap, same ? 0 : 310);
        return;
      }
      var r = range();
      for (var i = r[0]; i < r[1]; i++) {
        if (!state.picks[i]) {
          state.picks[i] = d;
          writeBack();
          render(true);
          pushIn(i, card);
          maybeAdvance();
          return;
        }
      }
      if (MOTION) card.querySelector('.nb-card-media').animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }], { duration: 156 });
    }
    function removeAt(i) {
      var r = range();
      if (i < r[0] || i >= r[1]) return;
      state.picks[i] = null;
      compact(r[0], r[1]);
      writeBack();
      clearTimeout(advanceTimer);
      render(true);
    }
    function removeOne(id) {
      var r = range();
      for (var i = r[1] - 1; i >= r[0]; i--) if (state.picks[i] && state.picks[i].id === id) { removeAt(i); return; }
    }

    /* ---------- beweging: design duwt zich in het vakje ---------- */
    function pushIn(index, card) {
      if (card && MOTION) card.querySelector('.nb-card-media').animate([{ transform: 'scale(1)' }, { transform: 'scale(.965)' }, { transform: 'scale(1)' }], { duration: 132, easing: 'ease-out' });
      if (!MOTION || !isOpen()) return;
      var slot = slotEls[index];
      if (!slot) return;
      var sImg = slot.querySelector('.nb-slot-img');
      if (sImg.decode && !(sImg.complete && sImg.naturalWidth)) { sImg.style.opacity = '0'; sImg.decode().then(function () { sImg.style.opacity = ''; }, function () { sImg.style.opacity = ''; }); }
      slot.querySelector('.nb-slot-img').animate([{ transform: 'scale(1.45)', opacity: 0 }, { transform: 'scale(.94)', opacity: 1, offset: 0.65 }, { transform: 'scale(1)', opacity: 1 }], { duration: 204, easing: 'cubic-bezier(.3,.7,.3,1)' });
      slot.querySelector('.nb-slot-box').animate([{ transform: 'scale(1)' }, { transform: 'scale(.9)', offset: 0.55 }, { transform: 'scale(1)' }], { duration: 204, easing: 'cubic-bezier(.3,.7,.3,1.2)' });
    }

    /* ---------- beweging: confetti (canvas, eenvoudige natuurkunde, twee golven + schokgolf) ---------- */
    var FX = { canvas: null, ctx: null, parts: [], rings: [], raf: 0, last: 0, dpr: 1 };
    var FX_COLOURS = ['#f6e9d2', '#ddbb8f', '#b98d5f', '#e9d1ac', '#ffffff', '#c9a27e', '#fbf1e4', '#8a6446'];
    function fxEnsure() {
      if (FX.canvas) return;
      var c = document.createElement('canvas');
      c.className = 'nb-confetti-canvas';
      c.setAttribute('aria-hidden', 'true');
      root.appendChild(c);
      FX.canvas = c; FX.ctx = c.getContext('2d');
      fxResize();
      window.addEventListener('resize', fxResize);
    }
    function fxResize() {
      if (!FX.canvas) return;
      FX.dpr = Math.min(window.devicePixelRatio || 1, window.innerWidth < 768 ? 1.5 : 2);
      FX.canvas.width = Math.round(window.innerWidth * FX.dpr);
      FX.canvas.height = Math.round(window.innerHeight * FX.dpr);
    }
    function fxLaunch(x, y, count, power) {
      for (var i = 0; i < count; i++) {
        var ang = Math.random() < 0.7 ? -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.35 : Math.random() * Math.PI * 2;
        var speed = (5 + Math.pow(Math.random(), 0.55) * 11) * power;
        var kind = Math.random(), shape = kind < 0.55 ? 'rect' : kind < 0.8 ? 'dot' : 'ribbon';
        FX.parts.push({
          x: x + (Math.random() - 0.5) * 16, y: y + (Math.random() - 0.5) * 16,
          vx: Math.cos(ang) * speed, vy: Math.sin(ang) * speed - 2.5 * power,
          w: shape === 'rect' ? 6 + Math.random() * 5 : shape === 'ribbon' ? 3.5 : 5 + Math.random() * 3,
          h: shape === 'rect' ? 9 + Math.random() * 6 : shape === 'ribbon' ? 14 + Math.random() * 10 : 0,
          shape: shape, color: FX_COLOURS[(Math.random() * FX_COLOURS.length) | 0],
          rot: Math.random() * Math.PI * 2, vr: (Math.random() - 0.5) * 0.28,
          tilt: Math.random() * Math.PI * 2, vtilt: 0.07 + Math.random() * 0.12,
          wob: Math.random() * Math.PI * 2, vwob: 0.04 + Math.random() * 0.07,
          life: 0, max: 130 + Math.random() * 70
        });
      }
      FX.rings.push({ x: x, y: y, r: 14, a: 0.55, max: 90 + power * 70 });
      if (!FX.raf) { FX.last = performance.now(); FX.raf = requestAnimationFrame(fxTick); }
    }
    function fxTick(now) {
      var dt = Math.min((now - FX.last) / 16.667, 2.5);
      FX.last = now;
      var ctx = FX.ctx;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, FX.canvas.width, FX.canvas.height);
      ctx.setTransform(FX.dpr, 0, 0, FX.dpr, 0, 0);
      for (var k = FX.rings.length - 1; k >= 0; k--) {
        var g = FX.rings[k];
        g.r += (g.max - g.r) * 0.12 * dt;
        g.a -= 0.022 * dt;
        if (g.a <= 0) { FX.rings.splice(k, 1); continue; }
        ctx.globalAlpha = g.a; ctx.strokeStyle = '#fbf1e4'; ctx.lineWidth = 2.5;
        ctx.beginPath(); ctx.arc(g.x, g.y, Math.max(0, g.r), 0, Math.PI * 2); ctx.stroke();
      }
      var drag = Math.pow(0.962, dt), H = window.innerHeight;
      for (var i = FX.parts.length - 1; i >= 0; i--) {
        var p = FX.parts[i];
        p.life += dt; p.vx *= drag; p.vy = p.vy * drag + 0.2 * dt;
        p.wob += p.vwob * dt; p.tilt += p.vtilt * dt; p.rot += p.vr * dt;
        p.x += (p.vx + Math.sin(p.wob) * 0.9) * dt; p.y += p.vy * dt;
        var alpha = p.life > p.max - 50 ? Math.max(0, (p.max - p.life) / 50) : 1;
        if (alpha <= 0 || p.y > H + 40) { FX.parts.splice(i, 1); continue; }
        ctx.globalAlpha = alpha; ctx.fillStyle = p.color;
        var c = Math.cos(p.rot), sn = Math.sin(p.rot), kk = FX.dpr;
        if (p.shape === 'dot') {
          var sy = 0.55 + Math.abs(Math.cos(p.tilt)) * 0.45;
          ctx.setTransform(kk * c, kk * sn, -kk * sn * sy, kk * c * sy, kk * p.x, kk * p.y);
          ctx.fillRect(-p.w / 2, -p.w / 2, p.w, p.w);
        } else {
          var sx = Math.cos(p.tilt);
          ctx.setTransform(kk * c * sx, kk * sn * sx, -kk * sn, kk * c, kk * p.x, kk * p.y);
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
      }
      ctx.globalAlpha = 1;
      ctx.setTransform(FX.dpr, 0, 0, FX.dpr, 0, 0);
      if (FX.parts.length || FX.rings.length) FX.raf = requestAnimationFrame(fxTick);
      else { FX.raf = 0; ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, FX.canvas.width, FX.canvas.height); }
    }
    function fxClear() { FX.parts.length = 0; FX.rings.length = 0; }
    function burstFrom(el, delay, count, power) {
      if (!MOTION || !el) return;
      fxEnsure();
      setTimeout(function () {
        if (!isOpen()) return;
        var r = el.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
        if (window.innerWidth < 768) count = Math.round(count * 0.55);
        fxLaunch(x, y, count, power || 1);
        setTimeout(function () { if (isOpen()) fxLaunch(x, y, Math.round(count * 0.45), (power || 1) * 0.7); }, 100);
      }, delay || 0);
    }

    /* ---------- klikken ---------- */
    track.addEventListener('click', function (e) {
      var card = e.target.closest('.nb-card');
      if (!card || card.classList.contains('is-out')) return;
      if (e.target.closest('.nb-step-minus')) { removeOne(card.dataset.id); return; }
      addPick(card);
    });
    (function dragScroll() {
      var down = false, moved = false, startX = 0, startLeft = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) moved = true;
        if (moved) track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () { down = false; });
      track.addEventListener('click', function (e) { if (moved) { e.stopImmediatePropagation(); e.preventDefault(); moved = false; } }, true);
    })();
    slotsEl.addEventListener('click', function (e) {
      var slot = e.target.closest('.nb-slot.is-editable');
      if (slot) startSwap(parseInt(slot.dataset.index, 10));
    });
    root.querySelector('.nb-swap-keep').addEventListener('click', function () { clearTimeout(advanceTimer); endSwap(); });
    root.querySelector('.nb-unlock-cta').addEventListener('click', function () { goPhase('free'); });
    root.querySelector('.nb-kit-cta').addEventListener('click', function () { goPhase('cart'); });
    root.querySelector('.nb-ship-tip').addEventListener('click', function (e) {
      var b = e.target.closest('.nb-tip-add');
      if (!b) return;
      e.stopPropagation();
      var x = EXTRAS.filter(function (y) { return y.id === b.dataset.id; })[0];
      if (!x) return;
      x.on = true;
      K.setAddon(x.id, true);
      buildKit();
      renderCart();
      renderUrgency();
      var box = root.querySelector('.nb-free-box');
      if (K.total() >= FREE_SHIP && box) {
        burstFrom(box, 60, 60, 0.6);
        if (MOTION) box.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.02)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'cubic-bezier(.2,.9,.3,1.3)' });
      }
    });
    root.querySelector('.nb-kit-list').addEventListener('click', function (e) { var li = e.target.closest('.nb-kit-item'); if (li) toggleExtra(li); });
    root.querySelectorAll('[data-nb-close]').forEach(function (el) { el.addEventListener('click', close); });
    // isConnected: een knop die tijdens de klik opnieuw is getekend (tip, extra's) telt niet als 'naast de box'
    root.addEventListener('click', function (e) { if (isOpen() && e.target.isConnected && !sheet.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapFocus(e);
    });

    var arrowsRaf = 0;
    function scheduleArrows() {
      if (arrowsRaf || !DESKTOP.matches) return;
      arrowsRaf = requestAnimationFrame(function () { arrowsRaf = 0; updateArrows(); });
    }
    var blurTimer = 0;
    function setBlur(px) { root.style.setProperty('--nb-blur-b', Math.max(0, Math.round(px)) + 'px'); }
    function clipBlur(delay) {
      clearTimeout(blurTimer);
      blurTimer = setTimeout(function () { if (isOpen()) setBlur(DESKTOP.matches ? 0 : sheet.offsetHeight - 40); }, delay || 0);
    }
    function updateArrows() {
      if (!DESKTOP.matches) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= max;
    }
    function page(dir) {
      var step = cards[0] ? (cards[0].offsetWidth + 15.6) * 5 : track.clientWidth;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', function () { page(-1); });
    nextBtn.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    /* ---------- foto's: allemaal laden bij openen ----------
       Oorzaak 'foto half zichtbaar na een plusje' (08-10): het vakje laadde een ander (240px) bestand dan de kaart,
       en dat moest nog binnenkomen terwijl het vakje al invloog. Nu: zelfde bestand + alles vooraf laden en decoderen. */
    var photosLoaded = false;
    function preloadPhotos() {
      if (photosLoaded) return;
      photosLoaded = true;
      cards.forEach(function (card) {
        var img = card.querySelector('.nb-card-media img');
        if (!img) return;
        img.loading = 'eager';
        if (img.decode) img.decode().catch(function () {});
      });
    }
    // Ook al beginnen zodra iemand de kiezer aanraakt (aantal sets, vakje of koopknop), vóór de box opent
    (function warmUp() {
      var wrap = K.cards[0] && document.querySelector('.nk-wrap');
      var go = function () { preloadPhotos(); };
      if (wrap) ['pointerdown', 'touchstart', 'focusin'].forEach(function (ev) { wrap.addEventListener(ev, go, { once: true, passive: true }); });
      var form = wrap && document.getElementById(wrap.dataset.form);
      if (form) ['pointerdown', 'touchstart'].forEach(function (ev) { form.addEventListener(ev, go, { once: true, passive: true }); });
    })();

    /* ---------- openen / sluiten ---------- */
    var opening = false;
    function open(want) {
      if (isOpen() || opening) return;
      opening = true;
      lastFocus = document.activeElement;
      state.swap = null;
      root.classList.remove('is-quiet');
      if (!added) sync();
      preloadPhotos();
      state.phase = added ? 'cart' : startPhase(want);
      if (state.phase === 'unlock') root.classList.add('is-quiet'); // terugkomen: geen herhaling van de confetti
      root.classList.add('no-anim');
      document.documentElement.classList.add('nb-locked');
      render(false);
      fitUnlock();
      sizeBg();
      root.setAttribute('aria-hidden', 'false');
      clearTimeout(blurTimer);
      setBlur(0);
      // naar het eerste gekozen of het eerste kiesbare design scrollen
      track.scrollLeft = 0;
      requestAnimationFrame(function () {
        opening = false;
        root.classList.add('is-open');
        clipBlur(470);
        if (state.phase === 'cart') animateUrgency();
        requestAnimationFrame(function () { root.classList.remove('no-anim'); });
      });
      if (MOTION) setTimeout(fxEnsure, 650);
      if (!added) readPrior();
      setTimeout(function () {
        updateArrows();
        var closeBtn = root.querySelector('.nb-close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }, 60);
    }
    function close() {
      clearTimeout(advanceTimer);
      if (state.swap) { state.phase = state.swap.back; state.swap = null; }
      fxClear();
      clearTimeout(blurTimer);
      setBlur(0);
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('nb-locked');
      if (added) { added = null; prior = { sets: 0, cents: 0, full: 0 }; root.classList.remove('nb-is-added'); state.phase = 'paid'; }
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function trapFocus(e) {
      var f = [].filter.call(sheet.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), [href], [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- mobiel: hele lade omlaag slepen om te sluiten ---------- */
    (function dragToClose() {
      var backdrop = root.querySelector('.nb-backdrop'), d = null;
      function isMobile() { return window.innerWidth < 768; }
      sheet.addEventListener('touchstart', function (e) {
        if (!isMobile() || !isOpen() || busy || e.touches.length !== 1) { d = null; return; }
        var t = e.touches[0];
        d = { x: t.clientX, y: t.clientY, t: Date.now(), dy: 0, fromTop: !!e.target.closest('.nb-handle, .nb-head, .nb-progress'), active: false, ignore: false };
      }, { passive: true });
      sheet.addEventListener('touchmove', function (e) {
        if (!d || d.ignore) return;
        var t = e.touches[0], dx = t.clientX - d.x, dy = t.clientY - d.y;
        if (!d.active) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dx) > Math.abs(dy) || dy < 0 || (sheet.scrollTop > 0 && !d.fromTop)) { d.ignore = true; return; }
          d.active = true; d.h = sheet.offsetHeight || 600;
          clearTimeout(blurTimer); setBlur(0);
          d.y = t.clientY; dy = 0;
          sheet.style.transition = 'none';
          if (backdrop) backdrop.style.transition = 'none';
        }
        e.preventDefault();
        d.dy = Math.max(0, dy);
        sheet.style.transform = 'translateY(' + d.dy + 'px)';
        if (backdrop) backdrop.style.opacity = String(Math.max(0, 1 - d.dy / d.h));
      }, { passive: false });
      function end() {
        if (!d || !d.active) { d = null; return; }
        var v = d.dy / Math.max(1, Date.now() - d.t);
        var shouldClose = d.dy > Math.min(140, d.h * 0.25) || v > 0.55;
        sheet.style.transition = ''; sheet.style.transform = '';
        if (backdrop) { backdrop.style.transition = ''; backdrop.style.opacity = ''; }
        if (shouldClose) close(); else clipBlur(460);
        d = null;
      }
      sheet.addEventListener('touchend', end);
      sheet.addEventListener('touchcancel', end);
    })();

    /* ---------- wat staat er al in de winkelwagen (nagelsets uit een eerdere ronde) ---------- */
    function readPrior() {
      var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(routes + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var sets = 0, cents = 0, fullC = 0;
          (c.items || []).forEach(function (i) {
            if (!/^press-on-nails-/.test(i.handle || '')) return;
            sets += i.quantity; cents += i.final_line_price; fullC += i.original_line_price;
          });
          prior = { sets: sets, cents: cents, full: fullC };
          if (state.phase === 'cart') renderCart();
        })
        .catch(function () {});
    }


    /* ---------- (02-11, Thomas) eerst echt in de winkelwagen, dan het overzicht ----------
       Grote knop op de pagina of in de box = 'Voeg toe aan winkelwagen': alles in één keer via cart/add.js, kiezer
       helemaal leeg, Kaching-lade blijft dicht en het overzicht opent met 'Door naar afrekenen' (glans) en
       'Ga door met shoppen'. Wat al in de mand zat telt mee als 'Al in je winkelwagen'. */
    var adding = false;
    function closeKaching() {
      try { if (window.kachingCartApi && kachingCartApi.refreshCart) kachingCartApi.refreshCart(); } catch (e) {}
      [0, 300, 800, 1500].forEach(function (ms) {
        setTimeout(function () {
          try { var kc = document.getElementById('kaching-cart'); if (kc && kc.classList.contains('active') && window.kachingCartApi && kachingCartApi.closeCart) kachingCartApi.closeCart(); } catch (e) {}
        }, ms);
      });
      setTimeout(function () { document.documentElement.classList.remove('nb-kc-mute'); }, 1900);
    }
    function cartNails(c) {
      var o = { sets: 0, cents: 0, full: 0 };
      (c.items || []).forEach(function (i) {
        if (!/^press-on-nails-/.test(i.handle || '')) return;
        o.sets += i.quantity; o.cents += i.final_line_price; o.full += i.original_line_price;
      });
      return o;
    }
    /* ---------- (02-11, Thomas) de gekozen sets vliegen zichtbaar naar het winkelwagenicoon ----------
       Bron: de vakjes op de pagina (of de regels in het overzicht als de box al open is); valt een bron buiten
       beeld, dan start de kaart bij de koopknop. Doel: #cart-icon-bubble (anders rechtsboven). Daarna tikt het
       icoon even aan en volgt pas het overzicht. Geen animatie bij 'beweging beperken'. */
    function flySources() {
      var vh = window.innerHeight, out = [];
      var inBox = isOpen();
      var imgs = inBox ? [].slice.call(root.querySelectorAll('.nb-view-cart .nb-line-thumb img'))
                       : [].slice.call(document.querySelectorAll('.nk-wrap .btf-starter-kit-slot-box img'));
      var sub = document.querySelector('.product-form__submit');
      var fb = sub ? sub.getBoundingClientRect() : { left: window.innerWidth / 2 - 30, top: vh - 120, width: 60, height: 60 };
      if (fb.bottom < 0 || fb.top > vh) fb = { left: window.innerWidth / 2 - 30, top: vh - 150, width: 60, height: 60 };
      imgs.forEach(function (im, i) {
        if (!im.offsetParent || !(im.currentSrc || im.src)) return;
        var r = im.getBoundingClientRect();
        if (r.width < 8 || r.bottom < 0 || r.top > vh) r = { left: fb.left + fb.width / 2 - 32 + (i - 1.5) * 26, top: fb.top + fb.height / 2 - 32, width: 64, height: 64 };
        out.push({ src: im.currentSrc || im.src, r: r });
      });
      return out.slice(0, 8);
    }
    function flyToCart(list, done) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!list.length || reduce || !document.body.animate) { done(); return; }
      var icon = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
      var ir = icon && icon.offsetParent ? icon.getBoundingClientRect() : null;
      if (!ir || ir.bottom < 0) ir = { left: window.innerWidth - 52, top: 14, width: 36, height: 36 };
      var tx = ir.left + ir.width / 2, ty = ir.top + ir.height / 2, DUR = 780, GAP = 120, left = list.length;
      list.forEach(function (it, i) {
        var s = Math.max(48, Math.min(96, it.r.width)), x0 = it.r.left + it.r.width / 2, y0 = it.r.top + it.r.height / 2;
        var el = document.createElement('div');
        el.className = 'nb-fly';
        el.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (x0 - s / 2) + 'px;top:' + (y0 - s / 2) + 'px;';
        el.innerHTML = '<img src="' + esc(it.src) + '" alt="">';
        document.body.appendChild(el);
        var dx = tx - x0, dy = ty - y0, lift = Math.min(160, Math.abs(dy) * 0.35 + 60);
        var a = el.animate([
          { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - lift) + 'px) scale(.8) rotate(' + (i % 2 ? 8 : -8) + 'deg)', opacity: 1, offset: 0.45 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.18) rotate(0deg)', opacity: .35 }
        ], { duration: DUR, delay: i * GAP, easing: 'cubic-bezier(.45,0,.25,1)', fill: 'both' });
        a.onfinish = function () {
          el.remove();
          if (icon && icon.animate) icon.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'ease-out' });
          if (--left === 0) setTimeout(done, 260);
        };
      });
    }

    /* (02-11 v6) mode 'checkout': in de mand en door naar /checkout; mode 'shop': in de mand, box dicht, kiezer leeg,
       kaartjes vliegen naar het winkelwagenicoon en de klant shopt verder. */
    function addToCart(onFail, mode) {
      if (adding || added) return false;
      if (!isOpen()) sync();
      if (state.picks.filter(Boolean).length < W) return false;
      adding = true;
      // Kaching opent bij elke mandwijziging zijn lade (pagina op slot, springt naar boven); tijdens ons toevoegen gedempt
      var html = document.documentElement;
      html.classList.add('nb-kc-mute');
      setTimeout(function () { html.classList.remove('nb-kc-mute'); }, 6000);
      var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var items = K.items(), snap = { cents: K.total(), full: K.fullTotal() }, before = { sets: 0, cents: 0, full: 0 };
      fetch(routes + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (c) { before = cartNails(c); }).catch(function () {})
        .then(function () {
          return fetch(routes + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
        })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j && j.status)) throw j; return j; }); })
        .then(function () {
          adding = false;
          var flights = mode === 'checkout' ? [] : flySources(); // vóór het legen: nog de gekozen designs
          // kiezer helemaal leeg (ook vakje 1), extra's uit: niets kan dubbel in de mand
          EXTRAS.forEach(function (x) { if (x.on) K.setAddon(x.id, false); });
          K.done();
          K.setPicks([]);
          if (mode === 'checkout') {
            window.location.href = routes + 'checkout';
            return;
          }
          checkoutBtn.classList.remove('is-loading');
          moreBtn.classList.remove('is-loading');
          closeKaching();
          if (isOpen()) close();
          flyToCart(flights, function () {});
        })
        .catch(function (j) {
          adding = false;
          document.documentElement.classList.remove('nb-kc-mute');
          checkoutBtn.classList.remove('is-loading');
          moreBtn.classList.remove('is-loading');
          if (onFail) onFail(j);
        });
      return true;
    }
    function boxFail(j) { errorEl.textContent = (j && j.description) || C.error; errorEl.hidden = false; }
    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.classList.contains('is-loading') || moreBtn.classList.contains('is-loading')) return;
      errorEl.hidden = true;
      if (addToCart(boxFail, 'checkout')) checkoutBtn.classList.add('is-loading');
    });
    moreBtn.addEventListener('click', function () {
      if (checkoutBtn.classList.contains('is-loading') || moreBtn.classList.contains('is-loading')) return;
      errorEl.hidden = true;
      if (addToCart(boxFail, 'shop')) moreBtn.classList.add('is-loading');
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { checkoutBtn.classList.remove('is-loading'); moreBtn.classList.remove('is-loading'); if (isOpen()) close(); } });

    window.ltNagelBox = { ready: true, open: open, close: close, state: state, add: addToCart, sync: sync };
  }

  if (window.ltNagelKiezer) boot();
  document.addEventListener('lt-nagelkiezer-ready', boot);
})();
